
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsa331a7acd1c9cf07bffba2942f59dac7en from './en.yaml'
            i18n.addResourceBundle('en', 'a331a7acd1c9cf07bffba2942f59dac7', flattenObject(nsa331a7acd1c9cf07bffba2942f59dac7en), true, true);
        
        export default 'a331a7acd1c9cf07bffba2942f59dac7';
    